// src/agreement.ts
var PENDING = "PENDING";
var SUBMITTED = "SUBMITTED";
var SIGNED = "SIGNED";
var COMPLETED = "COMPLETED";
var VOIDED = "VOIDED";
var CANCELED = "CANCELED";
var AGREEMENT_STATUSES = {
  PENDING,
  SIGNED,
  COMPLETED,
  VOIDED,
  CANCELED
};
export {
  AGREEMENT_STATUSES,
  CANCELED,
  COMPLETED,
  PENDING,
  SIGNED,
  SUBMITTED,
  VOIDED
};
//# sourceMappingURL=agreement.mjs.map